module.exports = __webpack_public_path__ + "static/img/Inspection12.f849b757.png";